import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const SyntheticBIcon = createIcon(
  'SyntheticB',
  <path d="M11,3 C12.5,3 13.92,3.34 15.2,3.94 C15.08,4.27 15,4.62 15,5 C15,6.35 15.9,7.5 17.13,7.87 C17.5,9.1 18.65,10 20,10 C20.18,10 20.35,9.98 20.52,9.95 C20.83,10.91 21,11.94 21,13 C21,18.52 16.52,23 11,23 C5.48,23 1,18.52 1,13 C1,7.48 5.48,3 11,3 Z M12,16 L10,16 L10,18 L12,18 L12,16 Z M11,8 C10.45,8 10,8.45 10,9 L10,13 C10,13.55 10.45,14 11,14 C11.55,14 12,13.55 12,13 L12,9 C12,8.45 11.55,8 11,8 Z M20,2 C20.55,2 21,2.45 21,3 L21,4 L22,4 C22.55,4 23,4.45 23,5 C23,5.55 22.55,6 22,6 L21,6 L21,7 C21,7.55 20.55,8 20,8 C19.45,8 19,7.55 19,7 L19,6 L18,6 C17.45,6 17,5.55 17,5 C17,4.45 17.45,4 18,4 L19,4 L19,3 C19,2.45 19.45,2 20,2 Z" />
);

export default SyntheticBIcon;
